import { IconBoxOffice, IconImportCSV, IconOfflineSale, IconUsers } from '@components/icons';
import { ProcessBoxOffice } from '@components/process-box-office';
import { ProcessImportCsv } from '@components/process-import-csv';
import { ProcessInviteGuest } from '@components/process-invite-guest';
import { ProcessOfflineSales } from '@components/process-offline-sales';

import { BOX_OFFICE, IMPORT_CSV, INVITE_GUEST, OFFLINE_SALES } from './modal-context.type';

export const ACTION_MODALS = {
  [INVITE_GUEST]: {
    name: 'InviteGuest',
    component: () => <ProcessInviteGuest />,
    icon: IconUsers,
  },
  [BOX_OFFICE]: {
    name: 'BoxOffice',
    component: () => <ProcessBoxOffice />,
    icon: IconBoxOffice,
  },
  [OFFLINE_SALES]: {
    name: 'OfflineSales',
    component: () => <ProcessOfflineSales />,
    icon: IconOfflineSale,
  },
  [IMPORT_CSV]: {
    name: 'ImportCsv',
    component: () => <ProcessImportCsv />,
    icon: IconImportCSV,
  },
};
